// 事件总线
class EventBus {
    constructor() {
        this.list = {};
    }
    on(name, fn) {
        const list = this.list[name] || [];
        list.push(fn);
        this.list[name] = list;
    }
    emit(name, ...args) {
        const fns = this.list[name];
        if (fns) {
            fns.forEach((fn) => {
                fn.apply(this, args || []);
            });
        }
    }
    off(name) {
        if (this.list[name])
            delete this.list[name];
    }
    clear() {
        this.list = {};
    }
}
export default new EventBus;
